import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-930c94da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "change-phone"
}
const _hoisted_2 = { class: "countryCode" }
const _hoisted_3 = {
  key: 0,
  class: "setPhone",
  src: "https://static-s.theckb.com/BusinessMarket/Client/signup/signup_ja.png",
  alt: ""
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { updateUser } from '@/apis/login'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { t } from '@/plugins/i18n'
import { ElMessage, dayjs } from 'element-plus'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getSignUpValue, setSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.SIGNUP_MODAL)
const route = useRoute()
const store = useStore()
const user = computed(() => store.getters.user)
console.log(user, 'user')
const key = 'phone-input-date'
const date = dayjs().format('YYYY-MM-DD')
const keyItem = localStorage.getItem(key)
const showChangePhone = ref<boolean>(false)

/** 是否录入了手机号 */
const hasPhone = ref<boolean>(false)
const phone = ref<string>('')

// 关闭弹窗
const closeChangePhone = async () => {
  localStorage.setItem(key, date)
  showChangePhone.value = false
  await setSignUpValue('1')
}
watch(() => route.path, async () => {
  let modalOpen = '1'
  if (store.getters.isLogin) {
    modalOpen = await getSignUpValue()
  }
  showChangePhone.value = (!user?.value?.customerMobile) && route.path.endsWith('/hub/ec') && user?.value?.superCustomerId && keyItem !== date && modalOpen !== '1'
}, {
  immediate: true
})
onMounted(() => {
  hasPhone.value = !!user.value?.customerMobile
})

/** 提交手机号 */
const submitPhone = () => {
  if (/^[\d]{6,20}$/.test(phone.value)) {
    updateUser({
      customerMobile: phone.value,
      countryCode: user.value.countryCode
    } as any).then((res) => {
      if (res.code === '0') {
        setSignUpValue('1')
        showChangePhone.value = false
        hasPhone.value = true
      }
    })
  } else {
    ElMessage.error(t('手机号格式不正确，请重新输入'))
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (showChangePhone.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", { class: "closeIcon" }, [
            _createElementVNode("i", {
              class: "iconfont icon-guanbibeifen1",
              onClick: closeChangePhone
            })
          ]),
          (!hasPhone.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`inputBox_${_unref(user)?.langcode}`)
                }, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(user)?.countryCode), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
                    class: "input",
                    maxlength: "16",
                    type: "number"
                  }, null, 512), [
                    [_vModelText, phone.value]
                  ])
                ], 2),
                (_unref(user)?.langcode === 'ja')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "setPhone",
                      src: `https://static-jp.theckb.com/static-asset/client/signup_${_unref(user)?.langcode}.png`,
                      alt: ""
                    }, null, 8, _hoisted_4)),
                _createElementVNode("div", {
                  class: "submit",
                  onClick: submitPhone
                })
              ], 64))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "setPhone",
                src: `https://static-jp.theckb.com/static-asset/client/signup_success_${_unref(user)?.langcode}.png`,
                alt: ""
              }, null, 8, _hoisted_5))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})